module.exports = __webpack_public_path__ + "static/media/loc1_img10.57f2521a.jpg";